import { Base2Presenter } from "core/presenter";
import { OmsRepository } from "core/repository";

class CompanyIntegrationsOmsPresenter extends Base2Presenter {
  initialState() {
    return {
      data: [],
      errors: {},
      companyUuid: ""
    };
  }

  onStart() {
    this.load();
  }

  async load() {
    const companyUuid = this.routeParams.companyUuid;
    const currentUser = await this.mRuntime.get("currentUser");

    this.enqueue({ loading: true });
    const result = await OmsRepository.getOms(
      companyUuid === "minha-empresa" ? currentUser.company_uuid : companyUuid
    );

    if (result.success) {
      this.enqueue({ data: result.data });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos buscar as integrações para esta empresa! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }
}

export default CompanyIntegrationsOmsPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/oms/presenter.js